
import { DisplayedNoticeStatus, RideitNotice } from '@/models/Rideit/RideitNotice';
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  components: {
  }
})
export default class RideitNoticeStatus extends Vue {

  @Prop({ required: true }) private notice: RideitNotice;
  
  get statusText() {
    return this.$t(`rideIt.notice.status.${DisplayedNoticeStatus[this.notice.displayedStatus]}`);
  }

  get statusColor() {
    switch (this.notice.displayedStatus) {
      case DisplayedNoticeStatus.Draft:
        return '';
      case DisplayedNoticeStatus.Active:
        return 'accent';
      case DisplayedNoticeStatus.Inactive:
        return '';
      case DisplayedNoticeStatus.Deleted:
        return 'red';
      default:
        return '';
    }
  }

}
